import api from './interceptor';

const BASE_URL_V2 = 'api/v2/questions';

export default {
  // API Version 2
  getProviderQuestionKeys: (params) => api.get(`${BASE_URL_V2}/provider`, { params }),
  getClinicAllQuestions: () => api.get(`${BASE_URL_V2}/clinic`),
  getProviderAllQuestions: () => api.get(`${BASE_URL_V2}/provider`),
};
